import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import queryString from 'query-string'
import moment from 'moment-timezone'


function getLeadInsights(closureType, filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'})
  let token = sessionStorage.getItem("authentication")
  return fetch(`${casaApiUrl}/users/lead-insights/${closureType}/filter?${query}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Authorization':  'Bearer ' + token
    },
    method: 'GET'
  }).then(r => r.json())
}


function getLeadDropInsights(filter) {
  return getLeadInsights('drops', filter)
}

function getLeadSoldInsights(filter) {
  return getLeadInsights('sold', filter)
}

function getLeadClosureLeaders(closureType, filter) {
  let {startDate, endDate, storeNames} = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    startDate: startDateParam,
    endDate: endDateParam
  }, {arrayFormat: 'bracket'})
  return fetch(`${casaApiUrl}/users/lead-insights/${closureType}-leaders/filter?${query}`, {
    credentials: 'include',
    method: 'GET'
  }).then(r => r.json())
}


function getLeadDropLeaders(filter) {
  return getLeadClosureLeaders('drop', filter)
}

function getLeadSoldLeaders(filter) {
  return getLeadClosureLeaders('sold', filter)
}

export default {
  getLeadDropInsights,
  getLeadSoldInsights,
  getLeadDropLeaders,
  getLeadSoldLeaders,
}



// WEBPACK FOOTER //
// ./src/services/lead-insights-service.js